import React, { useEffect, useState } from "react";
import "./OrderDetail.scss";
import { Steps, Timeline } from "antd";
import callApi from "../../utils/callApi";
import { ACCOUNTPATH, StatusOrder } from "../../utils/enum";

const OrderDetail = ({ orderId, onClose }) => {
  // const product ={
  //       "_id": "0435625621499032",
  //       "code": "ORDER_1737530060489iC4sF125ST",
  //       "name_owner": "Mai Đăng",
  //       "status": 3,
  //       "amount": 61750000,
  //       "amount_paid": 61750000,
  //       "owner": "9193597324071985",
  //       "address": "tinh_hai_duong, thanh_pho_hai_duong, xa_tien_tien, 123 đường Mai",
  //       "phone": "0379324239",
  //       "type": 1,
  //       "items": [
  //           {
  //               "product_name": "JASPER",
  //               "img": "https://www.lanhadecor.vn/assets/images/Copy_of_SOFA0071.jpg",
  //               "features": [
  //                   "Bố cục: Chỗ ngồi • layout 1",
  //                   "Vật liệu & màu sắc: Da Microfiber • VK503"
  //               ],
  //               "quantity": 1,
  //               "price_original": 26000000,
  //               "price_after": 26000000
  //           },
  //           {
  //               "product_name": "MAKI",
  //               "img": "https://www.lanhadecor.vn/assets/images/Sofa_co_ban-min-1200.png",
  //               "features": [
  //                   "Vật liệu & màu sắc: Vải nhung • LAR2041-7",
  //                   "Bố cục: Chỗ ngồi • 2 nệm"
  //               ],
  //               "quantity": 3,
  //               "price_original": 13000000,
  //               "price_after": 13000000
  //           }
  //       ],
  //       "delivery_date": "2025-02-05",
  //       "shipping_fee": 0,
  //       "payment_date": "2025-01-22",
  //       "voucher": 0,
  //       "discount": 0,
  //       "order_status_histories": [
  //           {
  //               "status":5,
  //               "is_failed": false,
  //               "created_at": "2025-01-23T03:41:13.223079Z"
  //           },
  //           {
  //               "status": 6,
  //               "is_failed": false,
  //               "created_at": "2025-01-23T03:41:35.592652Z"
  //           }
  //       ],
  //       "created_at": "2025-01-22T07:14:20.692093Z",
  //       "updated_at": "2025-01-22T07:14:20.692112Z"
  //   };


  const stepsData = [
    { num :5 , title: "Xác nhận đơn hàng", date: "05/01/2025", status: "finish" },
    { num :6 , title: "Sản xuất", date: "07/01/2025", status: "finish" },
    { num :1 , title: "Giao hàng", date: null, status: "process" },
    { num :2 , title: "Giao thành công", date: null, status: "wait" },
  ];



  const { Step } = Steps;

  const [product, setProduct] = useState(null);

  const fetchOrderDetail = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        authorization: `Bearer ${authToken}`,
      };
      const response = await callApi(
        `${ACCOUNTPATH.ORDER}${orderId}`,
        "GET",
        null,
        headers
      );
      console.log(response.data.data)
      setProduct(response.data.data);
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (orderId) {
      fetchOrderDetail();
      console.log(updatedSteps);
    }
  }, [orderId]);

  const getStatusText = (status) => {
      switch (status) {
        case StatusOrder.PAID: return "Đã xác nhận";
        case StatusOrder.PRODUCING: return "Đang sản xuất";
        case StatusOrder.TRANSPORT: return "Giao hàng";
        case StatusOrder.COMPLETE: return "Giao thành công";
        case StatusOrder.CANCELED: return "Giao thất bại";
        default: return "Trạng thái không xác định";
      }
    };

    const completedSteps = new Set(
      product?.order_status_histories.map((history) => history.status)
    );
    
    const currentStatus = product?.status;
    
    const updatedSteps = stepsData.map((step) => {
      if (product?.order_status_histories.some(history => history.status === step.num)) {
        return { ...step, status: "finish" };
      }
      if (step.num === product?.status) {
        return { ...step, status: "process" };
      }
      if (product?.status === 3 && step.num === 2) {
        return { ...step, status: "fail", title: "Giao thất bại" };
      }
      return { ...step, status: "wait" };
    });

  return (
    <div className="order-detail-wrapper">
      <div className="order-detail">
        <section className="order-section">
          <div className="group-back">
            <button className="back-button" onClick={onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M13.9995 17.6537L8.3457 11.9999L13.9995 6.34619L15.0532 7.39994L10.4532 11.9999L15.0532 16.5999L13.9995 17.6537Z"
                  fill="#121212"
                />
              </svg>
            </button>
            <h1 className="order-id">#{product?._id}</h1>
          </div>

          <span className={`order-status status-${product?.status}`}> {getStatusText(product?.status)}</span>
        </section>

        <section className="timeline">
          <Steps current={1} labelPlacement="vertical" responsive={false}>
            {updatedSteps.map((step, index) => (
              <Step
                key={index}
                title={step.title}
                // description={step.date || ""}
                status={step.status}
              />
            ))}
          </Steps>
        </section>

        <section className="details">
          <div className="info-block">
            <h2>Thông Tin Nhận Hàng</h2>
            <p className="info-label">
              Người nhận: <strong>{product?.name_owner}</strong>
            </p>
            <p className="info-label">
              Điện thoại: <strong>{product?.phone}</strong>
            </p>
            <p className="info-label">
              Địa chỉ nhận hàng: <strong> {product?.address}</strong>
            </p>
          </div>
          <div className="info-block">
            <h2>Thanh Toán</h2>
            <p className="info-label">
              Phương thức thanh toán:{" "}
              <strong>{product?.payment_date}</strong>
            </p>
            <p className="info-label">
              Số thẻ:  <strong>{product?.payment_date}</strong>
            </p>
          </div>
        </section>

        <section className="product-list">
          <table>
            <thead>
              <tr>
                <th>SẢN PHẨM</th>
                <th>SỐ LƯỢNG</th>
                <th>GIÁ</th>
              </tr>
            </thead>
            <tbody>
              {product?.items.map((item, index) => (
                <tr key={index}>
                  <td className="item-info">
                    <img src={item.img} alt={item.product_name} />
                    <span>{item.name}</span>
                  </td>
                  <td>{item.quantity}</td>
                  <td>
                    <div className="price">
                      <span className="original-price">
                        {item.price_original.toLocaleString()} đ
                      </span>
                      <span className="discount-price">
                        {item.price_after.toLocaleString()} đ
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="total">
          <div className="group-text">
            <p>
              <strong>Tổng tiền:</strong>{" "}
              {product?.amount.toLocaleString()} đ
            </p>
            <p>
              <strong>Phí vận chuyển:</strong>{" "}
              {product?.shipping_fee.toLocaleString()} đ
            </p>
            <p>
              <strong>Giảm giá:</strong> {product?.discount.toLocaleString()}{" "}
              đ
            </p>
            <p>
              <strong>Mã voucher:</strong> {product?.voucher}
            </p>
          </div>
          <h3>
            <strong>Tổng giá:</strong> {product?.amount.toLocaleString()}{" "}
            đ
          </h3>
        </section>
      </div>
    </div>
  );
};

export default OrderDetail;
